// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/get-safety-hook-lookup-request-schema',
  type: 'object',
  required: [],
  properties: {
    canFastenOnCounterbatten: {
      type: 'boolean',
    },
    groupName: {
      type: 'string',
    },
    safetyHookType: {
      type: 'string',
    },
    standardScrewThickness: {
      type: 'integer',
    },
    standardScrewLength: {
      type: 'integer',
    },
    counterbattenScrewLength: {
      type: 'integer',
    },
    minimumScrewDepth: {
      type: 'integer',
    },
    siHaDocumentationId: {
      type: 'integer',
    },
    screwType: {
      type: 'string',
    },
    screwConnectionMustBeDocumented: {
      type: 'boolean',
    },
    id: {
      type: 'integer',
    },
    key: {
      type: 'string',
    },
    searchCriteria: {
      type: 'string',
    },
    'paging.CurrentPage': {
      type: 'integer',
    },
    'paging.PageSize': {
      type: 'integer',
    },
    'paging.IncludeCount': {
      type: 'boolean',
    },
    'paging.NoPaging': {
      type: 'boolean',
    },
  },
} as IJSONSchema;

export default schema;
